module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('div', {
    staticClass: "title-acknowPage"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781429997973_toc01#toctitle1",
      "id": "title1"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACKNOWLEDGMENTS")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("In addition to the usual sources that a nonfiction author would use in the writing of a book about true events, such as interviews and site visits, the following media sources were consulted for information, and attributions are made throughout the book where applicable: the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Spokesman-Review")]), _vm._v("; the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Seattle Times")]), _vm._v("; "), _c('em', {
    staticClass: "i"
  }, [_vm._v("USA Today")]), _vm._v("; the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Bismarck Tribune")]), _vm._v("; "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Billings Gazette")]), _vm._v("; the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Pacific Northwest Inlander")]), _vm._v("; Fox News; CNN; MSNBC; "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Globe")]), _vm._v(" magazine; "), _c('em', {
    staticClass: "i"
  }, [_vm._v("The National Enquirer")]), _vm._v(" and Internet sites such as "), _c('a', {
    attrs: {
      "href": "http://fifthnail.blogspot.com",
      "target": "_blank"
    }
  }, [_c('span', [_c('span', {
    staticClass: "url"
  }, [_vm._v("http://fifthnail.blogspot.com")])])]), _vm._v(". Dialogue used throughout the book was either obtained from a direct source, or it was based on witness statements that appeared both in the news media, some of which are listed above, and in official sources. I would like to also acknowledge the work of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Coeur d’Alene Press")]), _vm._v(" staff writer Dave Turner, who carefully and painstakingly reported every detail of the Wolf Lodge murders case as it developed.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26034402","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429997973_ack01.vue
// module id = 66
// module chunks = 0